import { IntlShape } from "react-intl";

const getInfoText = (intl: IntlShape, isSetupFinished: boolean, isSyncFailed: boolean) => {
  if (isSyncFailed) {
    return intl.formatMessage({
      id: "settings.calendar.infoField.setupFailed",
      defaultMessage: "Sync paused. Your calendar client requires you to re-authorize this sync.",
      description: "Title of settings calendar info field - setup is failed",
    });
  }

  return isSetupFinished
    ? intl.formatMessage({
        id: "settings.calendar.infoField.setupFinished",
        defaultMessage: "Calendar sync currently active",
        description: "Title of settings calendar info field - setup is finished",
      })
    : intl.formatMessage({
        id: "settings.calendar.infoField.setupNotFinished",
        defaultMessage: "Email connected, but setup still required",
        description: "Title of settings calendar info field - setup is not finished",
      });
};

export default getInfoText;
